import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DigitalAssetSelectors from '../../../../modules/domain/digitalAsset/selectors'
import { useAction } from '@agro-club/frontend-shared'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import { DigitalAssetFileSize } from '../../../../types/entities'
import { DigitalAssetListRequestFilter } from '../../../../modules/domain/digitalAsset/types'
import GenericSelect from '../../Generics/GenericSelect'

/* Select component for filtering digital assets using its file size. File size range is defined in the backend
 *
 * Reference: {@link DigitalAssetFileSize}
 * */
const DAFileSizeFilterSelect: React.FC = () => {
  const { t } = useTranslation('digitalAsset')
  const filter = useSelector(DigitalAssetSelectors.filter)
  const filterUpdated = useAction(DigitalAssetActions.filterUpdated)
  let { size } = filter
  const [sizeRanges, setSizeRanges] = useState<DigitalAssetFileSize[]>([])
  const filesizeSelectItems = [
    {
      label: '0MB - 5MB',
      value: DigitalAssetFileSize.S,
    },
    {
      label: '6MB - 10MB',
      value: DigitalAssetFileSize.M,
    },
    {
      label: '11MB - 20MB',
      value: DigitalAssetFileSize.L,
    },
    {
      label: '21MB+',
      value: DigitalAssetFileSize.XL,
    },
  ]

  const addToFilter = (fileSizeRanges: DigitalAssetFileSize[]) => {
    setSizeRanges(() => [...fileSizeRanges])
  }

  const handleFilterChange = useCallback(
    (newFilterValue: Partial<DigitalAssetListRequestFilter>) => {
      filterUpdated({ ...filter, ...newFilterValue })
    },
    [filterUpdated, filter],
  )

  const executeFilter = () => {
    size = sizeRanges
    handleFilterChange({ size })
  }

  return (
    <GenericSelect
      mode="multiple"
      maxTagCount="responsive"
      placeholder={t('select.fileSize')}
      title={t('select.fileSize')}
      options={filesizeSelectItems}
      applyButtonLabel={t('button.applyFilter')}
      onApply={executeFilter}
      onChange={addToFilter}
      parentContainerFlex={1}
    />
  )
}

export default DAFileSizeFilterSelect
